import {Typography} from "@mui/material";

export const WorkQueueCdpInfoContent = (selectorContractGridAPI) => {


    switch(selectorContractGridAPI) {

        case 'Dashboard':
            return {
                title: 'Returned Data Points',
                content: 'Select the Data Points that you want to see on the Dashboard.  ' +
                    'Choose the order in which they will display.'
            };

        default:
            // case 'Drilldown':
            return {
                title: 'Contract Data Points',
                content: (
                    <>
                        <Typography paragraph>
                            Contract Data Points represent the contractual terms,
                            assumptions, inputs, calculations, and other pieces
                            of information required to administer the ongoing
                            obligations associated with a Contract.
                        </Typography>

                        <ul>
                            <li>
                                Some Contract Data Points provide definition and
                                structure to an Individual Contract Model.
                            </li>

                            <li>
                                Some Contract Data Points are used directly in
                                calculations that determine obligations, payments,
                                residuals, royalties, participations, or other
                                contractual outcomes.
                            </li>

                            <li>
                                Some Contract Data Points serve both purposes,
                                helping define the Contract Model while also
                                participating in calculations.
                            </li>

                            <li>
                                Contract Data Points are displayed in the order
                                in which they were added to the Individual
                                Contract Model.
                            </li>

                            <li>
                                Only Contract Data Points displaying a
                                <strong> pencil icon</strong> on the left may
                                be edited.
                            </li>

                            <li>
                                A <strong>red pencil</strong> indicates that a
                                required value is missing and must be provided.
                            </li>

                            <li>
                                The top of the pencil column can be used to
                                filter the grid and locate editable or missing
                                values more easily.
                            </li>

                            <li>
                                Click the <strong>orange "e"</strong> icon to
                                view the logical expression associated with the
                                Contract Data Point Value.
                            </li>

                            <li>
                                Click the <strong>purple "m"</strong> icon to
                                view multiple values associated with the Contract
                                Data Point.
                            </li>

                            <li>
                                Hover over the <strong>gray "s"</strong> icon
                                to see the Source Master Contract from which the
                                Contract Data Point originated.
                            </li>

                            <li>
                                Click the <strong>gray "s"</strong> icon to open
                                and review the Source Master Contract.
                            </li>

                            <li>
                                Click the <strong>green "d"</strong> icon to view
                                the External Data records used to calculate or
                                derive the value.
                            </li>

                            <li>
                                Understanding the source, calculation logic,
                                supporting data, and dependencies of Contract
                                Data Points helps make the Contract Model
                                transparent, auditable, and easier to maintain.
                            </li>
                        </ul>
                    </>
                )
            };
    }

};





